<script>
export default {
    name: "ProjectsPdf",
    components: {
        ProjectDocumentsPage: () => import('@/views/pages/ProjectDocumentsPage'),
        DocumentEditorPage: () => import('@/views/pages/DocumentEditorPage'),
    },
    props: {
        idProject: {
            type: String,
        },
    },
    data() {
        return {
            selectedDocumentId: null,
            isShowDocument: false,
        };
    },
    computed: {
        uniqueDialogId() {
            return this.idProject + this.selectedDocumentId;
        },
    },
    methods: {
        onDocumentOpen({id}) {
            this.selectedDocumentId = id;
            this.isShowDocument = true;
        },
        onDocumentClose() {
            this.$refs.documentList.loadDocumentList();
            this.isShowDocument = false;
        },
        onDocumentUpdate() {
            this.$refs.documentList.loadDocumentList();
        },
    }
}
</script>

<template>
    <div v-if="idProject">
        <project-documents-page ref="documentList" :id="idProject" :open-document-as-page="false" @open-document="onDocumentOpen"></project-documents-page>
        <v-dialog
            v-if="isShowDocument"
            v-model="isShowDocument"
            :persistent="true"
            ref="document"
            max-width="99vw"
            max-height="99vw"
            :scrollable="false"
            :hide-overlay="false"
            content-class="document-dialog"
            :key="uniqueDialogId"
            :retain-focus="false"
        ><document-editor-page :id-project="idProject" :id="selectedDocumentId" :isModal="true" @close="onDocumentClose" @update="onDocumentUpdate"></document-editor-page></v-dialog>
    </div>
    <v-overlay 
        v-else
        :value="!idProject"
    >  
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
        style="position: fixed;"
      ></v-progress-circular>
    </v-overlay>
</template>

<style lang="scss">
.document-dialog {
    overflow: hidden;
    height: 100%;
    .document-editor {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .page-container {
            overflow-y: auto;
            height: calc(100% - 48px);
        }
    }
}
.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 99%;
}
</style>
